(() => {
  const moodAccordionSelector =
    "#link-shop-by-mood > .menu-drawer__inner-submenu > .menu-drawer__menu > li > details > summary";

  const handleMoodAccordion = (event) => {
    const summary = event.target.closest(moodAccordionSelector);
    if (!summary || !window.matchMedia("(max-width: 749px)").matches) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const details = summary.parentElement;
    const willOpen = !details.open;
    const list = details.parentElement.parentElement;

    list.querySelectorAll(":scope > li > details").forEach((item) => {
      item.open = item === details ? willOpen : false;
      item.classList.remove("menu-opening");
      const itemSummary = item.querySelector(":scope > summary");
      if (itemSummary) itemSummary.setAttribute("aria-expanded", String(item.open));
    });
  };

  document.addEventListener("click", handleMoodAccordion, true);

  const initialize = (root) => {
    if (!root || root.dataset.dsyInitialized === "true") return;
    root.dataset.dsyInitialized = "true";

    window.dataLayer = window.dataLayer || [];
    const track = (name, detail = {}) => {
      window.dataLayer.push({
        event: `dsy_home_${name}`,
        dsy_component: "homepage",
        ...detail
      });
    };

    root.addEventListener("click", (event) => {
      const tracked = event.target.closest("[data-dsy-track]");
      if (!tracked || !root.contains(tracked)) return;
      track(tracked.dataset.dsyTrack, {
        link_text: (tracked.dataset.dsyLabel || tracked.textContent || "").trim().replace(/\s+/g, " "),
        link_url: tracked.href || undefined,
        item_list_name: tracked.dataset.dsyListName || undefined
      });
    });

    if ("IntersectionObserver" in window) {
      const seen = new Set();
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const listName = entry.target.dataset.dsyList;
          if (!listName || seen.has(listName)) return;
          seen.add(listName);
          track("product_list_view", {
            item_list_name: listName,
            item_count: entry.target.querySelectorAll("[data-dsy-product-card]").length
          });
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.25 });
      root.querySelectorAll("[data-dsy-list]").forEach((list) => observer.observe(list));
    }

    const success = root.querySelector("[data-dsy-form-success]");
    if (success) {
      success.focus();
      track("newsletter_success");
    }
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll("[data-dsy-homepage]").forEach(initialize);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener("shopify:section:load", (event) => initializeAll(event.target));
})();
